import basicRest from '../common/CommonRestFunctions'

const baseLocationUrl = '/location'

export default {
  getLocations () {
    return basicRest.executeBasicAxiosGet(baseLocationUrl + '/list')
  },
  getBaseLocations () {
    return basicRest.executeBasicAxiosGet(baseLocationUrl + '/base-list')
  },
  getBatchesByLocation () {
    return basicRest.executeBasicAxiosGet(baseLocationUrl + '/batches-list')
  },
  saveLocation (locationInfo) {
    return basicRest.executeBasicAxiosPost(baseLocationUrl + '/save', locationInfo)
  },
  removeLocation (id) {
    return basicRest.executeBasicAxiosRemove(baseLocationUrl + '/remove/' + id)
  },
  getLocationTypes () {
    return basicRest.executeBasicAxiosGet('/location-type/list')
  },
  saveLocationType (locationType) {
    return basicRest.executeBasicAxiosPost('/location-type/save', locationType)
  },
  removeLocationType (id) {
    return basicRest.executeBasicAxiosRemove('/location-type/remove/' + id)
  }
}
